import { ReactNode } from 'react'
import { useRoutes } from '../hooks'
import { createRoutesFromChildren } from '../helpers'

interface RoutesProps {
  children?: ReactNode
}

export function Routes({ children }: RoutesProps) {
  return useRoutes(createRoutesFromChildren(children))
}
